import React, { useState, useEffect } from "react";
// import { useSelector } from "react-redux";
import { FormControl, InputLabel, Select, MenuItem, TextField } from "@mui/material";
// import { getMerchantConfig } from "features/config/configSlice";
// import { customSizeVariantApi } from "utils/api";

const SizeSelector = ({
  grouped,
  sizeAttributeId,
  onCustomSizeError,
  // relatedProducts,
  // title,
  // getProductDetails,
  // setVariantsLoader,
  variants,
  setSelectedVariant,
  onVariantSelected,
  selectedVariant,
  setCustomProperties,
  selectedProduct,
  setCustomProductGroupId,
}) => {
  const [noMatchingSize, setNoMatchingSize] = useState(false);

  useEffect(() => {
    onCustomSizeError?.(noMatchingSize);
    return () => onCustomSizeError?.(false);
  }, [noMatchingSize, onCustomSizeError]);

  const groupedKeys = Object.keys(grouped);
  // const isOdd = groupedKeys.length % 2 !== 0;

  // const [selectedGroup, setSelectedGroup] = useState(groupedKeys[0] || "");
  const [selectedGroup, setSelectedGroup] = useState("custom");
  const [selectedSize, setSelectedSize] = useState("");
  // const [selectedThickness, setSelectedThickness] = useState(title);
  const [unit, setUnit] = useState("in");
  const [customLength, setCustomLength] = useState("");
  const [customBreadth, setCustomBreadth] = useState("");
  const [customLengthError, setCustomLengthError] = useState(false);
  const [customBreadthError, setCustomBreadthError] = useState(false);
  const [checkingPrice, setCheckingPrice] = useState(false);

  // const merchantConfig = useSelector(getMerchantConfig);

  // Helper to extract and convert dimensions
  const convertDisplayValue = (valueStr) => {
    const match = valueStr.match(/(\d+)inchx(\d+)inch/i);
    if (!match) return valueStr;

    const [_, l, w] = match.map(Number);

    const convert = (val) => {
      switch (unit) {
        case "feet":
          return (val / 12).toFixed(2) + " ft";
        case "cm":
          return (val * 2.54).toFixed(1) + " cm";
        default:
          return val + " inch";
      }
    };

    return `${convert(l)} x ${convert(w)}`;
  };

  const parseVariantDimensions = (variantStr) => {
    const [lengthStr, widthStr] = variantStr.split("x");
    const lengthMatch = lengthStr?.match(/\d+/);
    const widthMatch = widthStr?.match(/\d+/);

    const length = lengthMatch ? parseInt(lengthMatch[0], 10) : 0;
    const width = widthMatch ? parseInt(widthMatch[0], 10) : 0;

    return { length, width };
  };

  const getNearestBiggerVariant = (reqLength, reqWidth) => {
    if (!reqLength || !reqWidth) {
      return selectedVariant;
    }

    const currentAttributeMap = (selectedVariant?.attributes || []).filter(
      (attr) =>
        sizeAttributeId != null
          ? String(attr.product_attribute) !== String(sizeAttributeId)
          : attr.attribute_name?.toLowerCase() !== "size"
    );

    return (
      variants
        .map((variant) => {
          const { length, width } = parseVariantDimensions(variant.title);
          return { variant, length, width };
        })
        .filter(({ length, width }) => length > 0 && width > 0)
        .filter(({ length, width, variant }) => {
          if (!(width >= reqWidth && length >= reqLength)) {
            return false;
          }

          if (currentAttributeMap.length === 0) {
            return true;
          }

          return currentAttributeMap.every((attr) =>
            variant.attributes?.some(
              (variantAttr) =>
                variantAttr.product_attribute === attr.product_attribute &&
                variantAttr.value === attr.value
            )
          );
        })
        .sort((a, b) => {
          const areaDiff = a.width * a.length - b.width * b.length;
          if (areaDiff !== 0) {
            return areaDiff;
          }

          return variants.indexOf(a.variant) - variants.indexOf(b.variant);
        })[0]?.variant
    );
  };

  useEffect(() => {
    // Set default size when group changes
    if (grouped[selectedGroup]?.length) {
      setSelectedSize(grouped[selectedGroup][0].value);
      let requiredVariant = variants.find((variant) =>
        variant.attributes.some(
          (item) =>
            item.attribute_name === "size" &&
            item.value_name === grouped[selectedGroup][0].value
        )
      );

      setSelectedVariant(requiredVariant);
    }

    if (selectedGroup !== "custom") {
      setCustomProperties([]);
      setCustomLength("");
      setCustomBreadth("");
    }
  }, [selectedGroup]);

  const isWholeNumber = (value) => value !== "" && /^\d+$/.test(value);

  useEffect(() => {
    if (customLength === "" || customBreadth === "") {
      setNoMatchingSize(false);
      setCustomProperties([]);
      return;
    }

    if (
      !isWholeNumber(customLength) ||
      !isWholeNumber(customBreadth) ||
      customLengthError ||
      customBreadthError
    ) {
      setNoMatchingSize(false);
      setCustomProperties([]);
      return;
    }

    const parsedLength = parseInt(customLength, 10);
    const parsedBreadth = parseInt(customBreadth, 10);

    if (Number.isNaN(parsedLength) || Number.isNaN(parsedBreadth)) {
      return;
    }

    const requiredVariant =
      getNearestBiggerVariant(parsedLength, parsedBreadth);

    setNoMatchingSize(!requiredVariant);
    if (!requiredVariant) {
      setCustomProperties([]);
      return;
    }

    if (requiredVariant) {
      setCustomProperties([
        { name: "Length Size", value: customLength },
        { name: "Breadth Size", value: customBreadth },
      ]);
      setCustomProductGroupId(selectedProduct.line_item_id);
      if (requiredVariant.variant_id !== selectedVariant?.variant_id) {
        setSelectedVariant(requiredVariant);
        onVariantSelected?.(requiredVariant);
      }
    }
  }, [
    customLength,
    customBreadth,
    customLengthError,
    customBreadthError,
    selectedVariant,
    onVariantSelected,
    variants,
    sizeAttributeId,
  ]);

  return (
    <div>
      <p style={{ marginBottom: "10px", fontSize: "16px", fontWeight: 700 }}>Choose your Size</p>
      <div style={{ display: "flex" }}>
        {/* Grid layout */}
        {/* <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: "16px",
            justifyItems: "center",
            marginBottom: "20px",
          }}
        >
          {groupedKeys.map((name, index) => {
            const isLastItem = isOdd && index === groupedKeys.length - 1;
            const isSelected = name === selectedGroup;

            return (
              <div
                key={name}
                style={{
                  gridColumn: isLastItem ? "span 2" : "auto",
                  textAlign: "center",
                  cursor: "pointer",
                  padding: "10px 20px",
                  color: isSelected ? "#fff" : "#333",
                  border: isSelected ? "none" : "1px solid #33333399",
                  width: "100%",
                  borderRadius: merchantConfig.use_rounded_edge_buttons
                    ? "8px"
                    : "0px",
                  backgroundColor: isSelected
                    ? merchantConfig.primary_theme_color
                    : "#fff",
                  fontSize: "14px",
                }}
                onClick={() => setSelectedGroup(name)}
              >
                <p style={{ textTransform: "uppercase", margin: 0 }}>{name}</p>
              </div>
            );
          })}
        </div> */}
        {/* <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            padding: "10px 20px",
            // marginLeft: "10px",
            marginBottom: "20px",
            color: selectedGroup === "custom" ? "#fff" : "#333",
            border: selectedGroup === "custom" ? "none" : "1px solid #33333399",
            width: "100%",
            borderRadius: merchantConfig.use_rounded_edge_buttons
              ? "8px"
              : "0px",
            backgroundColor:
              selectedGroup === "custom"
                ? merchantConfig.primary_theme_color
                : "#fff",
            textTransform: "uppercase",
            fontSize: "14px",
          }}
          onClick={() => setSelectedGroup("custom")}
        >
          CUSTOM SIZE
        </div> */}
      </div>

      {selectedGroup !== "custom" ? (
        <>
          <FormControl fullWidth size="small">
            <InputLabel id="unit-label">Unit of Measurement</InputLabel>
            <Select
              labelId="unit-label"
              id="unit"
              value={unit}
              label="Unit of Measurement"
              onChange={(e) => setUnit(e.target.value)}
            >
              <MenuItem value="in">Inches</MenuItem>
              <MenuItem value="feet">Feet</MenuItem>
              <MenuItem value="cm">Centimeters</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth sx={{ mt: 2 }} size="small">
            <InputLabel id="sizeDropdown-label">Length & Width</InputLabel>
            <Select
              labelId="sizeDropdown-label"
              id="sizeDropdown"
              value={selectedSize}
              label="Length & Width"
              onChange={(e) => {
                setSelectedSize(e.target.value);
                let requiredVariant = variants.find((variant) =>
                  variant.attributes.some(
                    (item) =>
                      item.attribute_name === "size" &&
                      item.value_name === e.target.value
                  )
                );

                setSelectedVariant(requiredVariant);
                onVariantSelected?.(requiredVariant);
              }}
            >
              {grouped[selectedGroup]?.map((item) => (
                <MenuItem key={item.id} value={item.value}>
                  {convertDisplayValue(item.value)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </>
      ) : (
        <FormControl fullWidth size="small">
          <TextField
            label="Length (in Inches)"
            variant="outlined"
            type="number"
            size="small"
            sx={{ mb: 2 }}
            value={customLength}
            onChange={(e) => {
              const value = e.target.value;
              if (Number(value) > 84) return;
              const isValid = value === "" || /^\d+$/.test(value);
              setCustomLengthError(value !== "" && !isValid);
              setCustomLength(value);
            }}
            inputProps={{ min: 30, max: 84 }}
            error={customLengthError}
            helperText={
              customLengthError ? "Only whole numbers are allowed" : ""
            }
          />
          <TextField
            label="Breadth (in Inches)"
            variant="outlined"
            type="number"
            size="small"
            value={customBreadth}
            onChange={(e) => {
              const value = e.target.value;
              if (Number(value) > 84) return;
              const isValid = value === "" || /^\d+$/.test(value);
              setCustomBreadthError(value !== "" && !isValid);
              setCustomBreadth(value);
            }}
            inputProps={{ min: 15, max: 84 }}
            error={customBreadthError}
            helperText={
              customBreadthError ? "Only whole numbers are allowed" : ""
            }
          />
          {noMatchingSize && (
            <p role="alert" style={{ color: "#A02923" }}>
              No matching size is available for these dimensions with the selected height and color.
            </p>
          )}
          {/* <Button
            variant="outlined"
            className="price-check"
            style={{ margin: "10px 0px" }}
            disabled={checkingPrice}
            onClick={() => {
              setCheckingPrice(true);
              customSizeVariantApi(
                merchantConfig.merchant_id,
                selectedVariant.product_id,
                selectedVariant.variant_id,
                customLength,
                customBreadth
              )
                .then((resp) => {
                  let updatedVariant = variants.filter(
                    (variant) => variant.variant_id == resp.data.variant_id
                  );
                  if (updatedVariant.length > 0) {
                    setSelectedVariant(updatedVariant[0]);
                    setCustomProperties(resp.data.properties);
                    setCustomProductGroupId(selectedProduct.line_item_id);
                  }
                })
                .catch((err) => {
                  console.log(err);
                })
                .finally(() => {
                  setCheckingPrice(false);
                });
            }}
          >
            {checkingPrice ? "Checking..." : "Check price"}
          </Button> */}
        </FormControl>
      )}

      {/* <FormControl fullWidth sx={{ mt: 2 }} size="small">
        <InputLabel id="thickness-label">Mattress Thickness</InputLabel>
        <Select
          labelId="thickness-label"
          id="thickness"
          value={selectedThickness}
          label="Mattress Thickness"
          onChange={(e) => {
            setSelectedThickness(e.target.value);
            setVariantsLoader(true);
            getProductDetails({ product_id: e.target.value });
          }}
        >
          {relatedProducts?.concat({ title, product_id: title }).map((item) => (
            <MenuItem key={item.product_id} value={item.product_id}>
              {item?.secondary_display_title || item?.title}
            </MenuItem>
          ))}
        </Select>
      </FormControl> */}
    </div>
  );
};

export default SizeSelector;
